import { products } from '../mock';

export default function BrandStrip() {
  const items = [...products, ...products];
  return (
    <section className="bg-[#0b0b0d] border-y border-white/5 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex items-center gap-8">
        <div className="shrink-0 pr-6 border-r border-white/10">
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/50">
            Our Brands
          </div>
        </div>
        <div className="relative flex-1 overflow-hidden">
          <div className="flex gap-14 animate-marquee whitespace-nowrap">
            {items.map((p, i) => (
              <span
                key={i}
                className="font-display text-2xl lg:text-3xl font-semibold text-white/40 hover:text-amber-400 transition-colors tracking-wide"
              >
                {p.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
